<template>
  <v-app>
    <v-app-bar
      dense elevation="1" height="64px"
      app color="header widgetsList--text" style="z-index:100">
      <div class="d-flex align-center">
        <a v-if="logoLink" :href="logoLink" target="_blank">
          <v-img
            id="appLogo"
            alt="GDi Smart Portal" class="shrink hidden-sm-and-down mr-4" contain
            max-width="36" :src="logoSrc" />
        </a>
        <v-img
          v-else
          id="appLogo" alt="GDi Smart Portal" class="shrink hidden-sm-and-down mr-4"
          contain max-width="36" :src="logoSrc" />
      </div>
      <v-toolbar-title class="headerText--text" style="font-size:17px;">
        {{ appName }}
      </v-toolbar-title>
      <AGSearchBar
        v-if="isWidgetAvailable.searchBar && !isOL && !isSmallScreen " @open-bottom-sheet="openBottomSheet" @close-bottom-sheet="closeBottomSheet"
        @feature-details-click="openFeatureDetails" />
      <v-spacer />
      <AGQuickSearch
        v-if=" isWidgetAvailable.quickSearch && layersLoaded && !isSmallScreen && !isOL"
        class="pr-2" />
      <OLQuickSearch
        v-if=" isWidgetAvailable.quickSearch && layersLoaded && !isSmallScreen && isOL"
        class="pr-2" />
      <v-menu
        bottom offset-y nudge-bottom="30"
        transition="slide-y-transition">
        <template #activator="{on, attrs}">
          <div v-if="loginMode === 1 || loginMode === 2" class="px-2">
            <v-icon
              v-bind="attrs" dense color="headerText"
              v-on="on">
              mdi-account-outline
            </v-icon>
          </div>
          <div
            v-else v-bind="attrs" class="px-2"
            v-on="on">
            <v-icon color="headerText">
              mdi-dots-vertical
            </v-icon>
          </div>
        </template>
        <ContextMenu @about-clicked="openAboutDialog" @settings-clicked="setShowSettings(true)" />
      </v-menu>
      <div v-if="isToolListDialog && !shrinkToXS" class="px-2">
        <v-icon
          dense color="headerText" small
          @click="dialogOpen = true">
          mdi-tools
        </v-icon>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      v-if="isToolListText && !shrinkToXS && isToolListCollapsedText && !expandedToolListText && acceptedTerms" color="widgetsList" :class="[{leftTextCssCollapsed: isToolListText && !shrinkToXS && isToolListCollapsedText}, 'elevation-2']"
      fixed permanent>
      <ToolList
        ref="toolList"
        :is-tool-list-text="isToolListText"
        :is-tool-list-left="isToolListLeft"
        :is-tool-list-right="isToolListRight" :is-tool-list-footer="isToolListFooter"
        :is-tool-list-collapsed-text=" isToolListCollapsedText"
        :is-tool-list-dialog="isToolListDialog" @open-subgroup="openSubgroup" />
      <v-icon
        class="ml-5"
        dense
        style="position:fixed; bottom:75px;"
        :color="iconColor"
        @click="expandedToolListText = !expandedToolListText">
        mdi-chevron-right
      </v-icon>
      <v-divider v-if="menuItem" color="gray" />
      <v-list
        v-if="menuItem"
        class="pa-0 pt-1"
        color="widgetsList" dark flat
        dense>
        <v-list-item-group>
          <v-list-item
            :id="menuItem.id" :key="menuItem.title" link
            :style="{
              borderLeft:
                (menuItem.id === activeTool || menuItem.id === centerActiveTool) && isToolListLeft
                  ? 'solid 3px ' + selectedIconBorderColor
                  : 'solid 3px rgb(255, 255, 255, 0)',
              borderRight:
                (menuItem.id === activeTool || menuItem.id === centerActiveTool) && isToolListRight
                  ? 'solid 3px ' + selectedIconBorderColor
                  : 'solid 3px rgb(255, 255, 255, 0)',
              backgroundColor:
                menuItem.id === activeTool || menuItem.id === centerActiveTool
                  ? 'rgb(255, 255, 255, 0.24)' : '',
            }"
            :ripple="false"
            @click="$refs.toolList.startTool(menuItem)">
            <BaseTooltip right>
              <template #activator="{on, attrs}">
                <v-icon
                  class="mr-4"
                  dense
                  v-bind="attrs" :color="menuItem.id === activeTool || menuItem.id === centerActiveTool ? iconColor : iconColor"
                  v-on="on">
                  {{ menuItem.icon }}
                </v-icon>
              </template>
              <span>{{ typeof (menuItem.tooltip) === 'string' ? menuItem.tooltip : menuItem.tooltip[language] }}</span>
            </BaseTooltip>
            <v-list-item-title>{{ typeof (menuItem.tooltip) === 'string' ? menuItem.tooltip : menuItem.tooltip[language] }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-else-if="isToolListText && !shrinkToXS && acceptedTerms" color="widgetsList" :class="[{leftTextCss: isToolListText && !shrinkToXS}, 'elevation-2']"
      fixed permanent>
      <ToolList
        ref="toolList"
        :is-tool-list-text="isToolListText"
        :is-tool-list-left="isToolListLeft"
        :is-tool-list-right="isToolListRight" :is-tool-list-footer="isToolListFooter"
        :is-tool-list-dialog="isToolListDialog" @open-subgroup="openSubgroup" />
      <v-divider v-if="menuItem" color="gray" />
      <v-icon
        v-if=" isToolListCollapsedText"
        class="ml-5"
        dense
        style="position:fixed; bottom:75px;"
        :color="iconColor"
        @click="expandedToolListText = !expandedToolListText">
        mdi-chevron-left
      </v-icon>
      <v-list
        v-if="menuItem"
        class="pa-0 pt-1"
        color="widgetsList" dark flat
        dense>
        <v-list-item-group>
          <v-list-item
            :id="menuItem.id" :key="menuItem.title" link
            :style="{
              borderLeft:
                (menuItem.id === activeTool || menuItem.id === centerActiveTool) && isToolListLeft
                  ? 'solid 3px ' + selectedIconBorderColor
                  : 'solid 3px rgb(255, 255, 255, 0)',
              borderRight:
                (menuItem.id === activeTool || menuItem.id === centerActiveTool) && isToolListRight
                  ? 'solid 3px ' + selectedIconBorderColor
                  : 'solid 3px rgb(255, 255, 255, 0)',
              backgroundColor:
                menuItem.id === activeTool || menuItem.id === centerActiveTool
                  ? 'rgb(255, 255, 255, 0.24)' : '',
            }"
            :ripple="false"
            @click="$refs.toolList.startTool(menuItem)">
            <BaseTooltip right>
              <template #activator="{on, attrs}">
                <v-icon
                  class="mr-4"
                  dense
                  v-bind="attrs"
                  :color="menuItem.id === activeTool || menuItem.id === centerActiveTool ? iconColor : iconColor"
                  v-on="on">
                  {{ menuItem.icon }}
                </v-icon>
              </template>
              <span>{{ typeof (menuItem.tooltip) === 'string' ? menuItem.tooltip : menuItem.tooltip[language] }}</span>
            </BaseTooltip>
            <v-list-item-title>{{ typeof (menuItem.tooltip) === 'string' ? menuItem.tooltip : menuItem.tooltip[language] }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="(isToolListLeft || isToolListRight) && !shrinkToXS && !isToolListCentered && acceptedTerms" color="widgetsList" :class="[{leftRightCss: (isToolListLeft || isToolListRight) && !shrinkToXS}, 'elevation-2']"
      :right="isToolListRight" fixed permanent>
      <ToolList

        :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
        :is-tool-list-footer="isToolListFooter" :is-tool-list-dialog="isToolListDialog" />
    </v-navigation-drawer>
    <v-navigation-drawer
      v-if="(isToolListLeft || isToolListRight) && !shrinkToXS && isToolListCentered && acceptedTerms" ref="navigationD" color="widgetsList"
      :class="[{leftRightCss: (isToolListLeft || isToolListRight) && !shrinkToXS}, 'elevation-2']" :right="isToolListRight" fixed
      permanent>
      <ToolList
        ref="widgetList"
        v-resize="getSize"
        :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
        :is-tool-list-footer="isToolListFooter" :is-tool-list-dialog="isToolListDialog" class="positionRelative"
        :style="{top: topPosition + 'px'}" />
    </v-navigation-drawer>
    <v-dialog
      v-model="dialogOpen"
      overlay-color="header"
      max-width="400px">
      <v-card elevation="0">
        <ToolList
          :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
          :is-tool-list-footer="isToolListFooter" :is-tool-list-dialog="isToolListDialog"
          @close-dialog="dialogOpen = false" />
      </v-card>
    </v-dialog>

    <v-card
      v-if="subgroupDialogOpen" class="absolutePosition" style="top:20%; left: calc(50% - 300px);"
      width="600px" elevation="3">
      <v-container class=" pa-0">
        <v-row>
          <v-col cols="11" align-self="center" class="text-left ellipsis pl-8">
            <span
              :style="{fontSize: '17px', letterSpacing: '1px'}"
              :class="['widgetsList--text']">{{ subgroupDialogTitle }}</span>
          </v-col>
          <v-col cols="1">
            <BaseTooltip bottom>
              <template #activator="{on, attrs}">
                <v-btn
                  v-bind="attrs" icon x-small
                  color="headerText" style="margin-bottom: 2px"
                  class="ml-0" v-on="on"
                  @click="subgroupDialogOpen = false">
                  <v-icon dark>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ labels.close }}</span>
            </BaseTooltip>
          </v-col>
        </v-row>
        <v-divider />

        <div style="overflow-x: hidden; overflow-y: auto; max-height: 400px;">
          <v-row class="px-3" style="padding: 25px;">
            <template v-for="menuItem in menuItemsTools">
              <v-col
                :key="menuItem.title"
                cols="3" align-self="center"
                class="px-0 mx-6 toolCard"
                @click="openWidgetFromSubgroupDialog(menuItem)">
                <v-hover v-slot="{hover}" close-delay="100">
                  <v-card
                    color="rgb(191, 200, 207)" :elevation="hover ? 3 : 0" :class="{'on-hover': hover}"
                    style="border: solid 1px rgba(0,0,0,0.5)">
                    <v-card-title>
                      <v-row justify="center" align="center">
                        <v-icon large color="black">
                          {{ menuItem.icon }}
                        </v-icon>
                      </v-row>
                    </v-card-title>
                    <v-card-text style="height:50px;" class="widget text-center">
                      <span>{{ typeof (menuItem.tooltip) === 'string' ? menuItem.tooltip : menuItem.tooltip[language] }}</span>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
            </template>
          </v-row>
        </div>
      </v-container>
    </v-card>
    <v-main v-if="acceptedTerms">
      <v-navigation-drawer
        v-if="layersLoaded" v-show="showPanel" color="widget"
        :width="onlyXS" :class="['cssPanel', {'leftTextCssPanel': isToolListText && expandedToolListText, 'leftCssPanel':( isToolListLeft && !isWidgetOnTheRight && !shrinkToXS) || (isToolListText && !expandedToolListText), 'rightCssPanel': isToolListRight && !shrinkToXS, 'footerCssPanel': isToolListFooter || shrinkToXS, 'noFooterCssPanel': !isToolListFooter && !shrinkToXS}]" :right="isWidgetOnTheRight"
        fixed permanent>
        <AGTOC
          v-if="isWidgetAvailable.toc && !isOL && previouslyOpenedWidgets.toc && newViewRender" v-show="activeTool === 'toc'" ref="agtoc"
          @open-layer-filter="setLayerForTocFiltering" @open-attribute-table="setLayerForTocAttributeTable" @open-layer-labeling="setLayerForTocLabeling"
          @open-layer-symbology="setLayerForTocSymbology"
          @open-add-view="openAddView" @open-add-service="openAddService" />
        <OLTOC v-if="isWidgetAvailable.toc && isOL && previouslyOpenedWidgets.toc" v-show="activeTool === 'toc'" />
        <AGBasemap v-if="isWidgetAvailable.basemap && !isOL && previouslyOpenedWidgets.basemap" v-show="activeTool === 'basemap'" ref="agbasemap" />
        <OLBasemap v-if="isWidgetAvailable.basemap && isOL && previouslyOpenedWidgets.basemap" v-show="activeTool === 'basemap'" />
        <AGXY v-if="isWidgetAvailable.gotoxy && !isOL && previouslyOpenedWidgets.gotoxy" v-show="activeTool === 'gotoxy'" />
        <OLXY v-if="isWidgetAvailable.gotoxy && isOL && previouslyOpenedWidgets.gotoxy" v-show="activeTool === 'gotoxy'" />
        <!-- custom tools - start -->
        <template v-for="(customTool, index) in sideCustomTools">
          <component
            :is="customTool.id"
            v-show="activeTool === customTool.id" v-if=" previouslyOpenedWidgets[customTool.id]" :key="index"
            :ref="customTool.id" @feature-details-click="openFeatureDetails" />
        </template>
        <!-- custom tools - end -->
        <AGSpatialSelection
          v-if="isWidgetAvailable.spatialSelection && !isOL && previouslyOpenedWidgets.spatialSelection" v-show="activeTool === 'spatialSelection'"
          @open-bottom-sheet="openBottomSheet" @close-bottom-sheet="closeBottomSheet"
          @feature-details-click="openFeatureDetails"
          @open-edit-attribute="openForEdit" />
        <OLSpatialSelection
          v-if="isWidgetAvailable.spatialSelection && isOL && previouslyOpenedWidgets.spatialSelection"
          v-show="activeTool === 'spatialSelection'"
          @open-bottom-sheet="openBottomSheet" />
        <AGSearch
          v-if="isWidgetAvailable.search && !isOL && previouslyOpenedWidgets.search" v-show="activeTool === 'search'"
          ref="searchRef"
          @open-bottom-sheet="openBottomSheet" @close-bottom-sheet="closeBottomSheet"
          @feature-details-click="openFeatureDetails"
          @open-feature-details="openFeatureDetails"
          @open-edit-attribute="openForEdit" />
        <OLSearch
          v-if="isWidgetAvailable.search && isOL && previouslyOpenedWidgets.search" v-show="activeTool === 'search'"
          @open-bottom-sheet="openBottomSheet" />
        <AGBookmarks v-if="isWidgetAvailable.bookmarks && !isOL && previouslyOpenedWidgets.bookmarks" v-show="activeTool === 'bookmarks'" />
        <OLBookmarks v-if="isWidgetAvailable.bookmarks && isOL && previouslyOpenedWidgets.bookmarks" v-show="activeTool === 'bookmarks'" />
        <AGStatus v-if="isWidgetAvailable.status && !isOL && previouslyOpenedWidgets.status" v-show="activeTool === 'status'" />
        <OLStatus v-if="isWidgetAvailable.status && isOL && previouslyOpenedWidgets.status" v-show="activeTool === 'status'" />
        <AGPrint v-if="isWidgetAvailable.print" v-show="activeTool === 'print' && previouslyOpenedWidgets.print" />
        <AGMeasure v-if="isWidgetAvailable.measure && !isOL && previouslyOpenedWidgets.measure" v-show="activeTool === 'measure'" />
        <OLMeasure v-if="isWidgetAvailable.measure && isOL && previouslyOpenedWidgets.measure" v-show="activeTool === 'measure'" />
        <AGViews v-if="isWidgetAvailable.views && !isOL && previouslyOpenedWidgets.views" v-show="activeTool === 'views'" @views-changes="changeBasemapAndToc" />
        <AGLinearReferencing v-if="isWidgetAvailable.linearReferencing && !isOL && previouslyOpenedWidgets.linearReferencing" v-show="activeTool === 'linearReferencing'" />
        <AGSpatialRelation
          v-if="isWidgetAvailable.spatialRelation && !isOL && previouslyOpenedWidgets.spatialRelation" v-show="activeTool === 'spatialRelation'"
          @open-bottom-sheet="openBottomSheet" @feature-details-click="openFeatureDetails" @open-edit-attribute="openForEdit" />
        <AGDraw v-if="isWidgetAvailable.draw && !isOL && previouslyOpenedWidgets.draw" v-show="activeTool === 'draw'" />
        <AGEditor v-if="editorCreated || (viewMode !== '3d' && isWidgetAvailable.editor && !isOL && previouslyOpenedWidgets.editor)" v-show="activeTool === 'editor' && !isBulkEditingActive" />
        <AGBulkEditor v-if="isWidgetAvailable.editor && !isOL && previouslyOpenedWidgets.editor" v-show="activeTool === 'editor' && isBulkEditingActive" />
        <AGElevation
          v-if="isWidgetAvailable.elevation && !isOL && previouslyOpenedWidgets.elevation" v-show="activeTool === 'elevation'"
          @close-bottom-sheet="closeBottomSheet"
          @open-bottom-sheet="openBottomSheet" />
        <Export v-if="isWidgetAvailable.export && !isOL && previouslyOpenedWidgets.export" v-show="activeTool === 'export'" />
        <Import v-if="isWidgetAvailable.import && !isOL && previouslyOpenedWidgets.import" v-show="activeTool === 'import'" @symbology-for-editing="openEditSymbology" />
        <DriveAnalysis v-if="isWidgetAvailable.driveAnalysis && !isOL && previouslyOpenedWidgets.driveAnalysis" v-show="activeTool === 'driveAnalysis'" @feature-details-click="openFeatureDetails" />
      </v-navigation-drawer>
      <v-card
        v-if="expandedFeatureDetails && featureDetailsVisible"
        color="elements"
        width="100"
        rounded="0"
        :style="{
          height: getCardsHeight,
          position: 'absolute',
          overflowY: 'auto',
          right: featureDetailsExpanded ? '640px' : '380px', zIndex:7}">
        <template v-for="(item, index) in featureDetailsItems">
          <v-card
            :key="index"
            :class="{'emptyResult': item.isEmpty}"
            elevation="0"
            width="100"
            rounded="0" :style="{
              paddingRight:'2px',
              paddingLeft: '2px',
              maxHeight: getCardsHeight,
              backgroundColor: item.title !== selectedFDItem.title ? selectedIconBorderColor : widgetColor,
              color: item.title !== selectedFDItem.title ? elementsText : selectedIconBorderColor
            }"
            @click="switchFeatureDetails(item)">
            <v-card-text :style="{fontSize:'12px', wordBreak: 'break-word', color: item.title !== selectedFDItem.title ? elementsText : selectedIconBorderColor}" class="text-center px-0 py-1 hoverBold">
              {{ item.title }}
            </v-card-text>
          </v-card>
        </template>
      </v-card>
      <v-navigation-drawer
        v-show="featureDetailsVisible"
        :class="['cssPanel', {'rightCssPanel': isToolListRight && !isWidgetOnTheRight && !shrinkToXS,
                              'leftCssPanel': isToolListLeft && isWidgetOnTheRight && !shrinkToXS,
                              'footerCssPanelDetails': isToolListFooter || shrinkToXS}]"
        :right="!isWidgetOnTheRight" fixed permanent
        :width="featureDetailsWidth" :height="featureDetailsHeight">
        <FeatureDetails
          ref="featureDetailsRef"
          :feature-details-length="featureDetailsLength"
          :is-result-open="isBottomSheetOpen"
          :is-full-size-result="fullsizeVSheet"
          :height-change="currentSheetHeight"
          :feature-details-visible="featureDetailsVisible"
          :expanded-history="featureDetailsExpanded"
          :parent-height="vSheetHeightModifier"
          :selected-f-d-item="selectedFDItem"
          @show-relation="showRelation"
          @open-feature-details="openFeatureDetailsFromIdentify"
          @close-click="closeFeatureDetails"
          @expand="featureDetailsExpanded = true"
          @shrink="featureDetailsExpanded = false"
          @open-edit-attribute="openForEdit" />
      </v-navigation-drawer>
      <template
        v-if="layersLoaded && showCustomToolDialog">
        <component
          :is="centerCustomTool.id" v-for="(centerCustomTool, index) in centerCustomTools" v-show="centerActiveTool === centerCustomTool.id"
          :key="index" :ref="centerCustomTool.id" />
      </template>
      <AGIdentify
        v-if="identifyActive() && layersLoaded && !isOL" ref="identifyRef"
        @feature-details-results-length="setBottomSheetLength"
        @feature-details-click="openFeatureDetails" />
      <OLIdentify v-if="layersLoaded && isWidgetAvailable.identify && isOL" />
      <AGWebMap
        v-if="!isOL && hasArcGISPortalLoginLogicFinished"
        :feature-details-visible="featureDetailsVisible"
        :expanded-tool-list-text="expandedToolListText"
        :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
        :is-tool-list-footer="isToolListFooter" :is-tool-list-text="isToolListText" :is-widget-on-the-left="!isWidgetOnTheRight"
        :is-current-coordinates-widget-enabled="isWidgetAvailable.currentCoordinates"
        @open-bottom-sheet="openBottomSheet"
        @open-feature-details="openFeatureDetails"
        @toggle-graphics-manager="toggleGraphicsManager"
        @toggle-snapping-manager="toggleSnappingManager"
        @toggle-current-coordinates="toggleCurrentCoordinates"
        @layers-initialized="setAreLayersReady"
        @close-bottom-sheet="resetSearch" />
      <OLWebMap
        v-if="isOL"
        :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
        :is-widget-on-the-left="!isWidgetOnTheRight"
        @toggle-graphics-manager="toggleGraphicsManager"
        @layers-initialized="setAreLayersReady" />
      <AGFilter v-if="layerForFiltering && layerForFiltering.url" :layer-for-filtering="layerForFiltering" @close-filter="setLayerForTocFiltering" />
      <AGLabeling v-if="layerForLabeling && layerForLabeling.url" :layer-for-labeling="layerForLabeling" @close-labeling="setLayerForTocLabeling" />
      <AGSymbology v-if="layerForSymbology && layerForSymbology.url" :layer-for-symbology="layerForSymbology" @close-symbology="setLayerForTocSymbology" />
      <portal-target name="symbolStyler" />
      <portal-target name="attachmentEditor" />

      <AGAddService v-if="addService" @close-add="closeAddService" />
      <AGAddView v-if="addView" @close-add="closeAddView" />
      <Settings v-if="showSettings" @close-settings="setShowSettings(false)" />
      <ConfigureSymbology v-if="showEditSymbology" :layer-for-symbology="layerForSymbologyEdit" @close-symbology="setShowEditSymbology(false)" />
      <v-sheet
        v-show="isBottomSheetOpen"
        id="bottomSheet"
        :width="bottomSheetWidth"
        :class="{bottomSheet: isBottomSheetOpen, fullscreen: isSmallScreen}"
        :style="{left: bottomSheetLeft, right: bottomSheetRight, zIndex:5001}"
        :height="currentSheetHeight"
        color="widget">
        <v-badge
          style="width:100%; height:100%;"
          overlap offset-x="50%" color="widget widgetText--text">
          <template #badge>
            <v-icon style="cursor: pointer" @click="resizeVSheet">
              {{ fullsizeVSheet ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
            </v-icon>
          </template>
          <AGElevationVisualizer
            v-if="isWidgetAvailable.elevation && !isOL && previouslyOpenedWidgets.elevation"
            v-show="fullsizeVSheet && activeTool === 'elevation'" @close-bottom-sheet="closeBottomSheet;$store.dispatch('unSetActiveTool')" />
          <AGResults
            v-if="!isOL && activeTool !== 'elevation'"
            v-show="fullsizeVSheet"
            :show-tabulator="!isBottomSheetResizeInProgress"
            :layer-for-attribute-querying="layerForAttributeQuerying"
            @open-edit-attribute="openForEdit"
            @open-edit-bulk="openForBulkEdit"
            @feature-details-click="openFeatureDetails"
            @close-bottom-sheet="closeBottomSheet" />
          <OLResults
            v-if="isOL && activeTool !== 'elevation'" v-show="fullsizeVSheet" :show-tabulator="!isBottomSheetResizeInProgress"
            @close-bottom-sheet="closeBottomSheet" />
        </v-badge>
      </v-sheet>
      <v-snackbar
        v-model="snackbar.isShown" style="z-index:100000" :color="snackbar.color"
        :timeout="snackbar.timeout">
        {{ snackbarLabels[snackbar.code] }}{{ snackbar.customText }}
        <v-btn
          v-if="!snackbar.hideBtn" color="accent" text
          @click="$store.dispatch('hideSnackbar')">
          {{ labels.close }}
        </v-btn>
      </v-snackbar>
      <AGGraphicsManager
        v-if="areLayersReady && !isOL" v-show="showGraphicsManager && !isSmallScreen"
        :feature-details-visible="featureDetailsVisible"
        :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
        :is-widget-on-the-left="!isWidgetOnTheRight" />
      <OLGraphicsManager
        v-if="areLayersReady && isOL" v-show="showGraphicsManager && !isSmallScreen"
        :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
        :is-widget-on-the-left="!isWidgetOnTheRight" />
      <AGSnappingManager
        v-if="areLayersReady && (previouslyOpenedWidgets.snappingManager || canActiveWidgetDraw) && !isOL"
        v-show="showSnappingManager && canActiveWidgetDraw && !isSmallScreen"
        :feature-details-visible="featureDetailsVisible"
        :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
        :is-widget-on-the-left="!isWidgetOnTheRight" />
      <AGStandardMenu
        v-if="isWidgetAvailable.standardMenu && layersLoaded && !isOL"
        ref="standardMenuRef"
        :feature-details-visible="featureDetailsVisible"
        :is-tool-list-left="isToolListLeft"
        :is-tool-list-right="isToolListRight"
        :is-widget-on-the-left="!isWidgetOnTheRight"
        @close-bottom-sheet="closeBottomSheet" />
      <OLStandardMenu
        v-if="isWidgetAvailable.standardMenu && layersLoaded && isOL"
        :is-tool-list-left="isToolListLeft"
        :is-tool-list-right="isToolListRight"
        :is-widget-on-the-left="!isWidgetOnTheRight"
        @close-bottom-sheet="closeBottomSheet" />
      <AGCurrentCoordinates
        v-if="isWidgetAvailable.currentCoordinates && !isOL && layersLoaded" v-show="showCurrentCoordinates"
        :is-shown="showCurrentCoordinates"
        :feature-details-visible="featureDetailsVisible"
        :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
        :is-widget-on-the-left="!isWidgetOnTheRight" />
      <CopyRight
        :feature-details-visible="featureDetailsVisible"
        :is-tool-list-left="isToolListLeft"
        :is-tool-list-right="isToolListRight"
        :is-widget-on-the-left="!isWidgetOnTheRight" />
    </v-main>
    <v-footer
      v-if="shrinkToXS || (isToolListFooter && !isToolListCentered && !shrinkToXS)" style="z-index: 300" color="widgetsList"
      app class="pa-0">
      <ToolList
        :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
        :is-tool-list-footer="isToolListFooter" :is-tool-list-dialog="isToolListDialog" />
    </v-footer>
    <v-footer
      v-else-if="isToolListFooter && !shrinkToXS" ref="footer" elevation="7"
      style="z-index: 300" color="widgetsList" app
      class="pa-0">
      <ToolList
        ref="widgetListFooter" v-resize="getSizeFooter" class="positionRelative"
        :is-tool-list-left="isToolListLeft" :is-tool-list-right="isToolListRight"
        :is-tool-list-footer="isToolListFooter" :is-tool-list-dialog="isToolListDialog" :style="{left: leftPosition + 'px'}" />
    </v-footer>
    <v-dialog v-model="aboutDialog" max-width="300">
      <v-card class="mx-auto text-center">
        <div class="text-center about-div">
          <v-img
            v-if="configJson.appConfig.logo"
            max-height="120"
            alt="GDi Smart Portal" :src="logoSrc" contain />
          <img
            v-else
            alt="GDi Smart Portal"
            :src="logoSrc">
        </div>
        <v-card-text class="pb-0">
          GDi Ensemble Smart Portal {{ softwareVersion }}
        </v-card-text>
        <v-card-title class="py-0">
          <div style="word-break: break-word; width: 100%;">
            Smart Viewer
          </div>
        </v-card-title>
        <v-card-text>
          <div>
            © 2022 GDi. {{ labels.aboutText }}
          </div>
        </v-card-text>
        <v-spacer />
        <div style="padding: 0px 20px 20px 20px">
          <BaseSecondaryBtn
            v-if="hasDisclaimer"
            :title="labels.openDisclaimer"
            @click="setOpenDisclaimer" />
        </div>
      </v-card>
    </v-dialog>
    <div v-if="!acceptedTerms">
      <Disclaimer />
    </div>
    <v-dialog v-model="openDisclaimer" max-width="600" max-height="500px">
      <Disclaimer is-about="true" />
    </v-dialog>
  </v-app>
</template>

<script>
import gdiSketch from '../../extendedEsriClasses/gdiSketch.js'
import OAuthInfo from '@arcgis/core/identity/OAuthInfo'
import esriId from '@arcgis/core/identity/IdentityManager'
import ToolList from '../../components/ToolList.vue'
import ContextMenu from '../../components/Miscellaneous/ContextMenu.vue'
import AGTOC from '../../components/TOC/AGTOC.vue'
import utilityMethods from '@/mixin/AG/utilityMethods.js'
import interact from 'interactjs'
import { spEsri } from '../../globals.js'
import featureLayerMixin from '@/mixin/AG/featureLayer.js'

export default {
  name: 'Home',
  components: {
    ToolList,
    ContextMenu,
    AGWebMap: () => import('../../components/WebMap/AGWebMap'),
    OLWebMap: () => import('../../components/WebMap/OLWebMap'),
    AGBasemap: () => import('../../components/Basemap/AGBasemap'),
    OLBasemap: () => import('../../components/Basemap/OLBasemap'),
    AGTOC,
    OLTOC: () => import('../../components/TOC/OLTOC'),
    AGIdentify: () => import('../../components/Identify/AGIdentify'),
    OLIdentify: () => import('../../components/Identify/OLIdentify'),
    AGSearch: () => import('../../components/Search/AGSearch'),
    OLSearch: () => import('../../components/Search/OLSearch'),
    AGSpatialSelection: () => import('../../components/SpatialSelection/AGSpatialSelection'),
    OLSpatialSelection: () => import('../../components/SpatialSelection/OLSpatialSelection'),
    AGQuickSearch: () => import('../../components/QuickSearch/AGQuickSearch'),
    OLQuickSearch: () => import('../../components/QuickSearch/OLQuickSearch'),
    AGBookmarks: () => import('../../components/Bookmarks/AGBookmarks'),
    OLBookmarks: () => import('../../components/Bookmarks/OLBookmarks'),
    AGStandardMenu: () => import('../../components/StandardMenu/AGStandardMenu'),
    OLStandardMenu: () => import('../../components/StandardMenu/OLStandardMenu'),
    FeatureDetails: () => import('../../components/FeatureDetails/FeatureDetails'),
    AGStatus: () => import('../../components/Status/AGStatus'),
    OLStatus: () => import('../../components/Status/OLStatus'),
    AGPrint: () => import('../../components/Print/AGPrint'),
    AGMeasure: () => import('../../components/Measure/AGMeasure'),
    OLMeasure: () => import('../../components/Measure/OLMeasure'),
    AGResults: () => import('../../components/Results/AGResults'),
    OLResults: () => import('../../components/Results/OLResults'),
    AGXY: () => import('../../components/GoToXY/AGGoToXY'),
    OLXY: () => import('../../components/GoToXY/OLGoToXY'),
    AGGraphicsManager: () => import('../../components/GraphicsManager/AGGraphicsManager'),
    OLGraphicsManager: () => import('../../components/GraphicsManager/OLGraphicsManager'),
    AGFilter: () => import('../../components/TOC/LayerCustomization/AGFilter'),
    AGLabeling: () => import('../../components/TOC/LayerCustomization/AGLabeling'),
    AGSymbology: () => import('../../components/TOC/LayerCustomization/Symbology/AGSymbology'),
    AGViews: () => import('../../components/Views/AGViews'),
    AGAddView: () => import('../../components/TOC/AGAddView'),
    AGAddService: () => import('../../components/TOC/AGAddService'),
    AGCurrentCoordinates: () => import('../../components/CurrentCoordinates/AGCurrentCoordinates'),
    AGLinearReferencing: () => import('../../components/LinearReferencing/AGLinearReferencing'),
    AGSpatialRelation: () => import('../../components/SpatialRelation/AGSpatialRelation'),
    AGDraw: () => import('../../components/Draw/AGDraw'),
    AGEditor: () => import('../../components/Editor/AGEditor'),
    AGBulkEditor: () => import('../../components/Editor/AGBulkEditor'),
    AGElevation: () => import('../../components/Elevation/AGElevation'),
    AGElevationVisualizer: () => import('../../components/Elevation/AGElevationVisualizer.vue'),
    AGSnappingManager: () => import('../../components/SnappingManager/AGSnappingManager'),
    Settings: () => import('../../components/Miscellaneous/Settings'),
    AGSearchBar: () => import('../../components/SearchBar/AGSearchBar'),
    CopyRight: () => import('../../components/Miscellaneous/CopyRight'),
    Disclaimer: () => import('../../components/Miscellaneous/Disclaimer'),
    Export: () => import('../../components/ExportImport/Export'),
    Import: () => import('../../components/ExportImport/Import'),
    ConfigureSymbology: () => import('../../components/ExportImport/Configure/ConfigureSymbology.vue'),
    DriveAnalysis: () => import('../../components/DriveAnalysis/DriveAnalysis.vue'),
  },
  mixins: [utilityMethods, featureLayerMixin],
  data () {
    return {
      // isOL, ol or arcgis flag
      isOL: false,
      isToolListLeft: false,
      isToolListRight: false,
      isToolListFooter: false,
      isToolListDialog: false,
      isToolListText: false,
      isToolListCollapsedText: false,
      expandedToolListText: true,
      isWidgetOnTheRight: false,
      isToolListCentered: false,
      dialogOpen: false,
      subgroupDialogOpen: false,
      menuItem: null,
      configJson: {},
      languages: [],
      isBottomSheetOpen: false,
      fullsizeVSheet: true,
      topPosition: 0,
      leftPosition: 0,
      featureDetailsVisible: false,
      featureDetailsExpanded: false,
      hasArcGISPortalLoginLogicFinished: false,
      aboutDialog: false,
      vSheetHeightModifier: 0,
      isBottomSheetResizeInProgress: false,
      areLayersReady: false,
      featureDetailsLength: 0,
      menuItemsTools: [],
      subgroupDialogTitle: '',
      showGraphicsManager: false,
      showSnappingManager: false,
      showCurrentCoordinates: false,
      showSettings: false,
      showEditSymbology: false,
      layerForSymbologyEdit: null,

      layerForAttributeQuerying: null,
      layerForFiltering: null,
      layerForLabeling: null,
      layerForSymbology: null,

      addView: false,
      addService: false,
      featureDetailsItems: [],
      selectedFDItem: { title: 'Info', type: 'info' },
      editorCreated: false,
      openDisclaimer: false,
    }
  },
  computed: {
    // should add a setter here (v-model snackbar.isShown shouldn't change isShown directly,
    // it should be done via mutator, because its in vuex
    getCardsHeight () {
      if (!this.isBottomSheetOpen) {
        return '100%'
      }
      if (this.currentSheetHeight !== '3%') {
        return `calc((100% - ${this.currentSheetHeight})`
      }
      return '97%'
    },
    expandedFeatureDetails () {
      return this.configJson.appConfig.expandedFeatureDetails
    },
    snackbar () {
      return this.$store.getters.getSnackbar
    },
    colorSchema () {
      return this.$store.getters.getConfigJson.colorSchema
    },
    widgetColor () {
      return this.colorSchema.widget
    },
    elementsText () {
      return this.colorSchema.elementsText
    },
    widgetTextColor () {
      return this.colorSchema.widgetText
    },
    selectedIconBorderColor () {
      return this.colorSchema.elements
    },
    selectedIconColor () {
      return this.colorSchema.header
    },
    headerText () {
      return this.colorSchema.header
    },
    iconColor () {
      return this.colorSchema.widgetsListIcons
    },
    newViewRender () {
      return this.$store.getters.getNewViewRender
    },
    previouslyOpenedWidgets () {
      return this.$store.getters.getPreviouslyOpenedWidgets
    },
    sideCustomTools () {
      const sideCustomTools = []
      if (this.configJson.customTools) {
        for (const customTool of this.configJson.customTools) {
          if (customTool.position === 'side') {
            sideCustomTools.push(customTool)
          }
        }
      }
      return sideCustomTools
    },
    centerCustomTools () {
      const centerCustomTools = []
      if (this.configJson.customTools) {
        for (const customTool of this.configJson.customTools) {
          if (customTool.position === 'center') {
            centerCustomTools.push(customTool)
          }
        }
      }
      return centerCustomTools
    },
    layersLoaded () {
      return this.$store.getters.getLayersLoaded
    },
    snackbarLabels () {
      return this.getLabels(this.$store.getters.getLanguage).snackbarCodes
    },
    labels () {
      return this.getLabels(this.$store.getters.getLanguage).home
    },
    language () {
      return this.$store.getters.getLanguage
    },
    isSmallScreen () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    onlyXS () {
      return this.isSmallScreen ? this.$vuetify.breakpoint.width : 380
    },
    featureDetailsWidth () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return this.$vuetify.breakpoint.width
      }
      return this.featureDetailsExpanded ? 640 : 380
    },
    featureDetailsHeight () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'calc(100% - 120px)'
      }
      if (!this.isBottomSheetOpen && !this.isToolListFooter) {
        return 'calc(100% - 64px)'
      }
      if (!this.isBottomSheetOpen && this.isToolListFooter) {
        return 'calc(100% - 120px)'
      }
      if (this.isBottomSheetOpen && !this.isToolListFooter) {
        return `calc((100% - ${this.currentSheetHeight}) - 64px - 1px + 29px)`
      }
      if (this.isBottomSheetOpen && this.isToolListFooter && !this.fullsizeVSheet) {
        return 'calc(100% - 125px)'
      }
      return `calc((100% - ${this.currentSheetHeight}) - 64px - 1px + 29px - 30px)`
    },
    loginMode () {
      return this.$store.getters.getHasLogin
    },
    shrinkToXS () {
      return this.$vuetify.breakpoint.xsOnly
    },
    activeTool () {
      return this.$store.getters.getActiveTool
    },
    centerActiveTool () {
      return this.$store.getters.getCenterActiveTool
    },
    showPanel () {
      return !!this.activeTool
    },
    showCustomToolDialog () {
      return !!this.centerActiveTool
    },
    appName () {
      let title = 'Smart Viewer'
      const language = this.$store.getters.getLanguage
      const localizations = this.$store.getters.getConfigJson.appConfig.localization
      if (!localizations) {
        return title
      }
      for (const localization of localizations) {
        if (localization.id === language) {
          title = localization.name
          break
        }
      }
      return title
    },
    logoSrc () {
      return this.configJson.appConfig.logo ? this.configJson.appConfig.logo : require('@/assets/logo.png')
    },
    logoLink () {
      return this.configJson.appConfig.logoLink ? this.configJson.appConfig.logoLink : ''
    },
    isWidgetAvailable () {
      const configInfo = {}
      if (this.configJson.widgets.length > 0) {
        for (const widget of this.configJson.widgets) {
          configInfo[widget.id] = widget.configured && !this.$store.getters.getForbiddenWidgets?.[widget.id]
        }
      }
      if (this.$store.getters.getHasLogin === 0 || (this.$store.getters.getHasLogin === 2 && !this.$store.getters.getLoggedInUser) || this.$store.getters.getLicense !== 'Advanced') {
        configInfo.editor = false
      }
      this.$store.dispatch('setEditorEnabled', configInfo.editor)
      return configInfo
    },
    bottomSheetWidth () {
      if (this.isSmallScreen) {
        return '100%'
      }
      let toolsListWidth = this.isToolListDialog || this.isToolListFooter ? '0px' : '64px'
      if (this.isToolListText) {
        if (this.expandedToolListText) {
          toolsListWidth = '220px'
        } else {
          toolsListWidth = '64px'
        }
      }
      let widgetWidth = 0

      if (this.activeTool) {
        widgetWidth = this.onlyXS
      }
      return `calc(100% - ${widgetWidth}px - ${toolsListWidth})`
    },
    bottomSheetLeft () {
      let leftValue = 0
      if (this.activeTool && !this.isWidgetOnTheRight) {
        leftValue += 380
      }
      if (this.isToolListLeft) {
        leftValue += 64
      }
      if (this.isToolListText) {
        if (this.expandedToolListText) {
          leftValue += 220
        } else {
          leftValue += 64
        }
      }
      return leftValue + 'px'
    },
    bottomSheetRight () {
      let rightValue = 0
      if (this.activeTool && this.isWidgetOnTheRight) {
        rightValue += 380
      }
      if (this.isToolListRight) {
        rightValue += 64
      }
      return rightValue + 'px'
    },
    sheetHeight () {
      return this.isSmallScreen ? '100%' : '45%'
    },
    currentSheetHeight () {
      return this.fullsizeVSheet ? `calc(${this.sheetHeight} + ${this.vSheetHeightModifier}px)` : '3%'
    },
    refs () {
      return this.$refs
    },
    selectedView () {
      return this.$store.getters.getViewObject
    },
    viewMode () {
      return this.$store.getters.getConfigJson?.appConfig?.view ? this.$store.getters.getConfigJson.appConfig.view : '2d'
    },
    canActiveWidgetDraw () {
      return this.$store.getters.getCanActiveWidgetDraw
    },
    softwareVersion () {
      return process.env.VUE_APP_VERSION
    },
    isBulkEditingActive () {
      return this.$store.getters.getBulkEdit
    },
    acceptedTerms () {
      return this.$store.getters.getHasDisclaimer ? this.$store.getters.getAcceptedTerms : true
    },
    hasDisclaimer () {
      return this.$store.getters.getHasDisclaimer
    },
  },
  watch: {
    canActiveWidgetDraw (newValue) {
      this.snappingLayerManger(newValue)
    },
    isSmallScreen (newValue) {
      if (newValue) {
        this.disableVSheetResize()
      } else {
        this.initVSheetResize()
      }
    },
    fullsizeVSheet (newValue) {
      if (!newValue) {
        this.disableVSheetResize()
      } else {
        this.initVSheetResize()
      }
    },
    activeTool (newValue, oldValue) {
      if (oldValue === 'editor') {
        this.$store.dispatch('setCustomEdit', false)
        this.$store.dispatch('setBulkEdit', false)
        this.$store.dispatch('setEditFeature', null)
        this.$store.dispatch('setEditLayerURL', null)
      }
      if (!newValue) {
        spEsri.sketchWidget.cancel()
      } else if (newValue !== 'toc') {
        this.addView = false
      } else {
        this.$store.dispatch('setNewViewRender', true)
      }
    },
  },
  created () {
    if (this.$store.getters.getOrganisationPortalUrl) {
      this.loadArcGISPortalCredentials()
    } else {
      this.hasArcGISPortalLoginLogicFinished = true
    }

    this.configJson = this.$store.getters.getConfigJson
    this.isOL = !!this.configJson.isOL
    this.buildUILayout()

    const localization = this.configJson?.appConfig?.localization
    if (localization) {
      for (const language of localization) {
        this.languages.push({
          id: language.id,
          title: language.id,
        })
      }
    }
    const views = this.$store.getters.getViewObject
    if (views) {
      this.$store.dispatch('setActiveTool', 'views')
    }
    const hiddenGroupLayers = this.configJson.operationalMaps.find(e => e.hiddenGroupLayers?.length > 0)
    if (hiddenGroupLayers) {
      this.$store.dispatch('addPreviouslyOpenedWidget', 'toc')
    }
    this.createEditor()
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
    spEsri.sketchWidget = gdiSketch
    this.initVSheetResize()
  },
  methods: {
    async snappingLayerManger (newValue) {
      if (newValue) {
        for (const key of spEsri.snappingLayers) {
          const fl = await this.getFeatureLayer(key)
          fl.opacity = 0
          fl.labelsVisible = false
          spEsri.map.add(fl)
        }
      } else {
        for (const key of spEsri.snappingLayers) {
          const fl = await this.getFeatureLayer(key)
          spEsri.map.remove(fl)
        }
      }
    },
    createEditor () {
      if (!this.editorCreated) {
        this.editorCreated = true
        return true
      }
      return false
    },
    showRelation (items) {
      this.featureDetailsItems = items.sort(function (a, b) {
        if (a.type < b.type) {
          return 1
        }
        if (a.type > b.type) {
          return -1
        }

        return 0
      })
      this.selectedFDItem = { title: 'Info', type: 'info' }
    },
    switchFeatureDetails (item) {
      this.selectedFDItem = item
    },
    setOpenDisclaimer () {
      this.aboutDialog = false
      this.openDisclaimer = true
    },
    openWidgetFromSubgroupDialog (menuItem) {
      this.$refs.toolList.startTool(menuItem)
      this.menuItem = menuItem
      this.subgroupDialogOpen = false
    },
    openSubgroup (item) {
      this.subgroupDialogTitle = item.title
      this.menuItemsTools = []
      for (const widget of item.widgets) {
        const index = this.$refs.toolList.menuItems.findIndex((x) => x.id === widget)
        const configWidget = this.configJson.widgets.find((x) => x.id === widget && x.configured)
        if (index !== -1 && configWidget && !this.$store.getters.getForbiddenWidgets?.[widget]) {
          this.menuItemsTools.push(this.$refs.toolList.menuItems[index])
        } else {
          const customTools = this.configJson.customTools
          const customTool = customTools?.find((x) => x.id === widget)
          if (customTool) {
            this.menuItemsTools.push({
              id: customTool.id,
              title: customTool.id,
              icon: customTool.icon,
              tooltip: customTool.title,
              position: customTool.position,
            })
          }
        }
      }
      this.subgroupDialogOpen = true
    },
    buildUILayout () {
      if (this.configJson.layout) {
        this.isToolListCollapsedText = this.configJson.layout.isToolListCollapsedText
        const toolListPosition = this.configJson.layout.layoutOption
        const widgetPosition = this.configJson.layout.widgetOption
        this.isToolListCentered = this.configJson.layout.widgetListPosition === 'center'

        switch (toolListPosition) {
          case 'right':
            this.isToolListRight = true
            break
          case 'left':
            this.isToolListLeft = true
            break
          case 'footer':
            this.isToolListFooter = true
            break
          case 'dialog':
            this.isToolListDialog = true
            break
          case 'textToolbox':
            this.isToolListText = true
            break
        }
        this.isWidgetOnTheRight = widgetPosition === 'right'
      } else {
        this.isToolListLeft = true
      }
    },

    openAboutDialog () {
      this.aboutDialog = true
    },
    changeBasemapAndToc () {
      if (this.$refs.agbasemap) {
        this.$refs.agbasemap.changeBasemap(this.selectedView.basemap)
      }
    },
    // necessary if user is refreshing the page or the arcgis portal token has expired
    async loadArcGISPortalCredentials () {
      const info = new OAuthInfo({
        appId: this.$store.getters.getPortalAppId,
        portalUrl: this.$store.getters.getOrganisationPortalUrl,
        popupCallbackUrl: window.location.protocol + '//' + window.location.host + (!window.location.host.includes('localhost') ? window.location.pathname : '') + '/oauth-callback.html',
        popup: true,
      })
      esriId.registerOAuthInfos([info])
      try {
        const noLoginPromptSignedInObject = await esriId.checkSignInStatus(info.portalUrl + '/sharing')
        this.$store.dispatch('setArcGISPortalToken', noLoginPromptSignedInObject.token)
        this.hasArcGISPortalLoginLogicFinished = true
      } catch (error) {
        if (this.configJson.operationalMaps?.length > 0) {
          const arcgisPortalServices = this.configJson.operationalMaps.filter(service => service.mapURL.includes(info.portalUrl.substring(0, info.portalUrl.lastIndexOf('/'))))
          const aProtectedServiceExists = await this.checkIfAServiceIsProtected(arcgisPortalServices)
          if (aProtectedServiceExists) {
            try {
              const loginPromptSignedInObject = await esriId.getCredential(info.portalUrl + '/sharing')
              this.$store.dispatch('setArcGISPortalToken', loginPromptSignedInObject.token)
            } catch (nestedError) {
              console.error(nestedError)
            } finally {
              this.hasArcGISPortalLoginLogicFinished = true
            }
          }
        }
      } finally {
        this.hasArcGISPortalLoginLogicFinished = true
      }
    },
    keyDownHandler (e) {
      if (e.key === 'Escape') {
        this.$store.dispatch('unSetActiveTool')
      }
    },
    openBottomSheet () {
      this.fullsizeVSheet = true
      this.isBottomSheetOpen = true
    },
    closeBottomSheet () {
      this.isBottomSheetOpen = false
      this.$store.dispatch('setAttributeTableResultsFlag', false)
      this.layerForAttributeQuerying = null
    },
    resetSearch () {
      this.closeBottomSheet()
      this.$refs.searchRef.resetWidget()
    },
    identifyActive () {
      if (!Object.prototype.hasOwnProperty.call(this.isWidgetAvailable, 'identify')) {
        return false
      } else if (Object.prototype.hasOwnProperty.call(this.isWidgetAvailable, 'identify') && !this.isWidgetAvailable.identify) {
        return false
      } else if (Object.keys(spEsri.mapImageLayers).length > 0 || Object.keys(spEsri.featureLayers).length > 0 ||
        Object.keys(spEsri.sceneLayers).length > 0 || spEsri.portalLayers.length > 0 || Object.keys(spEsri.buildingLayers).length > 0 || Object.keys(spEsri.wmsLayers).length > 0) {
        return true
      }
      return false
    },
    resizeVSheet () {
      this.fullsizeVSheet = !this.fullsizeVSheet
    },
    initVSheetResize () {
      interact('#bottomSheet').resizable({
        edges: { top: true },
        listeners: {
          start: () => {
            this.showGraphicsManager = false
            this.isBottomSheetResizeInProgress = true
          },
          move: (event) => {
            this.vSheetHeightModifier += -event.deltaRect.top
          },
          end: () => {
            this.isBottomSheetResizeInProgress = false
          },
        },
        inertia: {
          resistance: 5,
          minSpeed: 100,
          endSpeed: 50,
        },
        modifiers: [
          interact.modifiers.restrictSize({
            min: { height: 300 },
            // TODO dynamically update this rule, at runtime
            max: { height: window.innerHeight - 64 },
          }),
        ],
      })
    },
    disableVSheetResize () {
      interact('#bottomSheet').unset()
      this.vSheetHeightModifier = 0
    },
    getSize () {
      const widgetListHeight = this.$refs.widgetList.$el.clientHeight
      const navigationDrawerHeight = this.$refs.navigationD.$el.clientHeight
      this.topPosition = (navigationDrawerHeight - widgetListHeight - 16) / 2 - 32
    },
    getSizeFooter () {
      const widgetListWidth = this.$refs.widgetListFooter.$el.clientWidth
      const footerWidth = this.$refs.footer.$el.clientWidth
      this.leftPosition = (footerWidth - widgetListWidth) / 2
    },
    openFeatureDetails (featureLayer, fromIdentify) {
      this.selectedFDItem = { title: 'Info', type: 'info' }
      this.featureDetailsItems = [{ title: 'Info', type: 'info' }]
      if (!this.featureDetailsVisible) {
        this.featureDetailsExpanded = false
      }
      this.featureDetailsVisible = true
      this.$refs.featureDetailsRef.openFeatureDetails(featureLayer, fromIdentify)
    },
    openFeatureDetailsFromIdentify (objectIndex) {
      this.$refs.identifyRef.openFeatureDetails(objectIndex)
    },
    setBottomSheetLength (len) {
      this.featureDetailsLength = len
    },
    closeFeatureDetails () {
      this.featureDetailsVisible = false
      this.featureDetailsExpanded = false
    },
    setAreLayersReady () {
      this.areLayersReady = true
    },
    toggleGraphicsManager () {
      this.showGraphicsManager = !this.showGraphicsManager
      this.showSnappingManager = false
    },
    toggleSnappingManager () {
      this.showSnappingManager = !this.showSnappingManager
      this.showGraphicsManager = false
    },
    toggleCurrentCoordinates () {
      this.showCurrentCoordinates = !this.showCurrentCoordinates
    },
    setLayerForTocFiltering (layer) {
      this.layerForFiltering = layer
    },
    setLayerForTocLabeling (layer) {
      this.layerForLabeling = layer
    },
    setLayerForTocAttributeTable (layer) {
      this.layerForAttributeQuerying = null
      this.$store.dispatch('setAttributeTableResultsFlag', true)
      this.layerForAttributeQuerying = layer
      this.openBottomSheet()
    },
    setLayerForTocSymbology (layer) {
      this.layerForSymbology = layer
    },
    openAddView () {
      this.addView = true
    },
    openAddService () {
      this.addService = true
    },
    closeAddService () {
      this.addService = false
    },
    closeAddView () {
      this.addView = false
    },
    setShowSettings (val) {
      this.showSettings = val
    },
    setShowEditSymbology (val) {
      this.showEditSymbology = val
    },
    openForEdit () {
      this.$store.dispatch('unSetActiveTool')
      this.$store.dispatch('setBulkEdit', false)
      this.$store.dispatch('setCustomEdit', true)
      this.$store.dispatch('setActiveTool', 'editor')
    },
    openForBulkEdit () {
      this.$store.dispatch('unSetActiveTool')
      this.$store.dispatch('setCustomEdit', false)
      this.$store.dispatch('setBulkEdit', true)
      this.$store.dispatch('setActiveTool', 'editor')
    },
    openEditSymbology (layer) {
      this.layerForSymbologyEdit = layer
      this.showEditSymbology = true
    },
  },
}
</script>

<style>
.rotateStyle {
  border-radius:50%;
  background-color: rgba(255, 255, 255, 1) !important;
  position:absolute;
  top: 95%;
  left:97.5%;
}
.rotateStyle button {
    border-radius:50%;
    background-color: rgba(40, 40, 40, 0.85) !important;
}
.esri-view-width-less-than-small > .esri-view-root > .esri-ui {
  inset: 0px !important;
}
.left.esri-view-width-greater-than-small > .esri-view-root > .esri-ui {
  inset: 0px 0px 0px 64px !important;
}
.toolboxtext.esri-view-width-greater-than-small > .esri-view-root > .esri-ui {
  inset: 0px 0px 0px 220px !important;
}
.toolboxtextexpanded > .esri-view-root > .esri-ui {
  inset: 0px 0px 0px 64px !important;
}
.right.esri-view-width-greater-than-small > .esri-view-root > .esri-ui {
  inset: 0px 64px 0px 0px !important;
}
html,body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow-y: hidden;
}
#app {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
header {
  height: 64px  !important;
}
.leftRightCss{
  top: 64px !important;
  width: 64px !important;
}
.leftTextCss{
  top: 64px !important;
  width: 220px !important;
}
.leftTextCssCollapsed{
  top: 64px !important;
  width: 64px !important;
}
.leftCssPanel{
 left: 64px  !important;
}
.leftTextCssPanel{
 left: 220px  !important;
}
.rightCssPanel{
 right: 64px  !important;
}
.noFooterCssPanel {
  height: calc(100% - 64px) !important;
}
.cssPanel{
 top: 64px  !important;
}
.footerCssPanel{
 height: calc(100% - 120px) !important;
}
.footerCssPanelDetails{
 height: calc(100% - 120px);
}
.bottomSheet{
  position:absolute;
  bottom: 0px;
}
.fullscreen {
  left: 0px !important;
  right: 0px !important;
  z-index: 10000000;
}
.positionRelative {
  position: relative
}
* {
  scrollbar-width: auto !important;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(136, 136, 136, 0.527);
  border-radius: 10px;
}
/* Scrollbar Mozila */
* {
  scrollbar-width: thin;
}
/* Outlined filled - text field */
.v-text-field--outlined.v-text-field--filled:not(.v-text-field--single-line) input {
  margin-top: 0px;
}
.v-dialog {
  box-shadow: none !important;
}
.about-div {
  width: 100%;
  padding: 25px;
}
.absolutePosition {
    position: absolute;
    display: block;
    z-index: 100;
}
.toolCard:hover {
  cursor: pointer;
}
.hoverBold:hover {
  font-weight: 700 !important;
}
.emptyResult {
 opacity: 0.5 !important;
}
</style>
